// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getSubscriptionTypeById } from 'app/constants/enums/SubscriptionType/main';

/* eslint-disable max-len */
export const CORPORATE = getSubscriptionTypeById('Corporate');
export const COUPON = getSubscriptionTypeById('Coupon');
export const FREE = getSubscriptionTypeById('Free');
export const NONE = getSubscriptionTypeById('None');
export const PERIODIC = getSubscriptionTypeById('Periodic');
export const TRIAL = getSubscriptionTypeById('Trial');
/* eslint-enable max-len */
